export default __webpack_public_path__ + "static/media/image-overview-empty-graphic.794d8ba0.svg";